import { render } from "./LowerThirdsOutput.vue?vue&type=template&id=4b6117af&scoped=true"
import script from "./LowerThirdsOutput.vue?vue&type=script&lang=js"
export * from "./LowerThirdsOutput.vue?vue&type=script&lang=js"

import "./LowerThirdsOutput.vue?vue&type=style&index=0&id=4b6117af&scoped=true&lang=css"

import exportComponent from "../../../../../../../name-pronunciation/orator-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6117af"]])

export default __exports__